/*
 * Public API Surface of materials
 */

export * from './materials.module';
export * from './svg-icons.module';
